import { Component } from '@verndale/core';
import GlobalNavigation from './GlobalNavigation';
import UtilityNavigation from './UtilityNavigation';
import { useEffect, useState } from 'react';
import SearchGen from '../../components/searchGen';

class Header extends Component {
  globalNavigation: GlobalNavigation | null = null;
  utilityNavigation: UtilityNavigation | null = null;
  isMobile = false;

  constructor(el: HTMLElement) {
    super(el);

    if (this.dom.globalNavigation) {
      this.globalNavigation = new GlobalNavigation(
        this.dom.globalNavigation as HTMLElement
      );
    }

    if (this.dom.utilityNavigation) {
      this.utilityNavigation = new UtilityNavigation(
        this.dom.utilityNavigation as HTMLElement
      );
    }
    new SearchGen();
  }

  setupDefaults() {
    this.dom = {
      globalNavigation:
        this.el.querySelector<HTMLElement>('.global-navigation'),
      utilityNavigation: this.el.querySelector<HTMLElement>(
        ':scope > .utility-navigation'
      ),
      stickyTabModule: document.querySelector<HTMLElement>('.sub-menu')
    };

    this.isMobile =
      !window.matchMedia(`(min-width: ${768}px)`).matches &&
      !window.matchMedia(`(min-width: ${1440}px)`).matches;
  }

  addListeners() {
    if (!this.isMobile) {
      window.addEventListener('scroll', this.onScroll.bind(this));
    }
  }

  onScroll() {
    if (this.dom.stickyTabModule) {
      const stickyTabModule = this.dom.stickyTabModule as HTMLElement;
      const stickyTabModuleOffset = stickyTabModule.offsetTop;
      const stickyTabModuleHeight = stickyTabModule.offsetHeight;
      const stickyTabModuleBottom =
        stickyTabModuleOffset + stickyTabModuleHeight;
      if (
        window.pageYOffset > stickyTabModuleOffset &&
        window.pageYOffset < stickyTabModuleBottom
      ) {
        this.el.classList.add('header--hidden');
      } else {
        this.el.classList.remove('header--hidden');
      }
    }
  }

  currentPath() {
    const [currentURL, setCurrentURL] = useState<string>('');
    console.log('URL', currentURL);
  
    useEffect(() => {
      setCurrentURL(window.location.pathname);
    }, []); 
  
  }

}

export default Header;
